import { WEB_URL } from '@/config/endpoints';
import IMAGES from '@/public/assets/img';


export default {
    SeoContent:{
        title: 'Credlix | Global Supply Chain Financing Platform for Business',
        url: WEB_URL+'/en-us/about-us',
        description:'Learn about us, Credlix, and what makes us tech leading tech-enabled global supply chain finance platform.',
        keyword: '', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    banner:{
        bannerImage:IMAGES.ABOUTIMG.bannernew,
        bannerHeadingUnderlineText:'Global leader in technology',
        bannerHeadingText:'for the supply chain',
        bannerParaText:'We make your financing safer, easier and faster thanks to our technological approach and our experience in the supply chain with manufacturers around the world.',
    },


    aboutGlobalEnterprise:'Global Enterprises',
    cities:'Cities',
    section1Head:{
        WWD:'What do we do?',
        supplyChain:'Financing the entire supply chain',
    },
    section:[
        {para1: 'At Credlix, we have integrated Moglix’s expertise in end-to-end supply chain transformation for over <strong>700 enterprises </strong>and <strong>16,000 SMEs </strong>manufacturing in India and Southeast Asia, and exporting to over 53 <strong>countries worldwide </strong>, with our smart financial technology revolutionizing cash flow lending.',
        para2:'Founded in Singapore in 2015, Moglix has become one of the largest and fastest-growing digital supply chain solutions companies in Asia, leading in indirect procurement, SaaS contract management, warehousing and distribution of industrial goods.',
        image:IMAGES.ABOUTIMG.portship},
        {para1: 'At Credlix, we leverage Moglix’s unique full-stack operating system for B2B commerce, <strong>offering a tailor-made digital supply chain finance solution</strong>, connecting leading companies, suppliers, exporters, and lenders, ensuring that supply chain finance and exports never stop.',
        para2:'We don’t just lead with innovation, we <strong>transform the B2B financial industry</strong>. Our executive team is at the forefront of this revolution, delivering technologically advanced financial solutions that power commerce and manufacturing. With Credlix, the supply chain becomes an engine of unprecedented opportunity.',
        image:IMAGES.ABOUTIMG.standinggirl}
    ],
   


    meetTeam:{
        heading:'Meet the Team',
        para:"At Credlix, our executive leadership team brings along the strong experience of having worked in top technology, finance, and manufacturing companies to transform the way buyers, sellers, and exporters access working capital through automation in finance.",
        team:[
            {image:IMAGES.ABOUTIMG.rahulnew,name:'Rahul Garg',designation:'CEO & Founder'},
            {image:IMAGES.ABOUTIMG.rishabhnew,name:'Rishabh Agarwal',designation:'Senior Vice President'},
            {image:IMAGES.ABOUTIMG.sanjeevArora,name:'Sanjeev Arora',designation:'Chief Financial Officer'},
            {image:IMAGES.ABOUTIMG.pritamnew,name:'Pramit Joshi',designation:'Senior Director'},
            {image:IMAGES.ABOUTIMG.GenetteNew,name:'Genette Herrera',designation:'Mexico Leader'},
        ]
    },

}
